var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExport16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Export/export_16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8 Fill",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8286 3.82144L8 0.992889L5.17145 3.82144L5.87855 4.52855L7.5 2.90702V10.99H8.5V2.90702L10.1214 4.52855L10.8286 3.82144ZM2.5 12V13.5C2.5 13.7452 2.6771 13.9495 2.9102 13.9919L3 14H13C13.2452 14 13.4496 13.8229 13.4919 13.5898L13.5 13.5V12H14.5V13.5C14.5 14.2794 13.9049 14.9204 13.1444 14.9931L13 15H3C2.22057 15 1.57958 14.4049 1.50687 13.6444L1.5 13.5V12H2.5Z",
    fill: "#0057B8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport16);
export default __webpack_public_path__ + "static/media/export_16.c0df58ef40f6c08c4fc87dbe66fe2cfc.svg";
export { ForwardRef as ReactComponent };